import { Select } from '@zoopla-eng/zds/select';

const durationOptions = {
    '900': '15 minutes',
    '1800': '30 minutes',
    '2700': '45 minutes',
    '3600': '1 hour',
    '4500': '1 ¼ hour'
};

export type Duration = keyof typeof durationOptions;

type SelectMaxTravelTimeProps = {
    value: Duration;
    onChange: (duration: Duration) => void;
};

export const SelectMaxTravelTime = ({
    value,
    onChange
}: SelectMaxTravelTimeProps) => {
    const options = Object.keys(durationOptions).map((option) => ({
        text: durationOptions[option as Duration],
        id: option
    }));

    return (
        <Select
            label="Max travel time"
            selectedOption={
                options.find((option) => option.id === value) || options[0]
            }
            options={options}
            onSelectedOptionChange={(e) => {
                onChange(e.id as Duration);
            }}
        />
    );
};
